import React, { useContext } from 'react';
import BookerContext from '../../context/bookerContext';
import fieldParams from '../../const/fieldParams';
import { mixpanelEventTrack } from '../../services/mixpanel';

const PaymentInput = ({ fieldKey }) => {
  const { key, type, inputMode, label, placeholder } = fieldParams[fieldKey];
  const context = useContext(BookerContext);
  const {
    state: { step, payment, isWebBooker, selectedFleet, customToken },
    updateStep,
    updateEditor,
    updatePreviousStep,
  } = context;

  const onClickHandler = () => {
    if (customToken) return;
    if (step === 8) mixpanelEventTrack(isWebBooker ? 'switchPaymentRequestRideWebBook' : 'editPaymentRequestRide');
    console.log('PaymentInput onClickHandler step ', step);

    if (isWebBooker) {
      updateStep(6);

      if (!payment?.description) {
        updateEditor('');
        return;
      } else {
        updatePreviousStep(step);
      }
    } else {
      updateStep(step - 2);
    }
    updateEditor({ key });
  };

  if (isWebBooker && !selectedFleet) return <></>;

  return (
    <div className={`form-group form-group-${key}`}>
      <label htmlFor={key} className="form-label">
        {label}
      </label>
      <input
        name={key}
        id={key}
        type={type}
        inputMode={inputMode}
        className={`form-input ${key}`}
        value={payment?.description}
        readOnly={true}
        onClick={onClickHandler}
        {...(placeholder && { placeholder: placeholder })}
      />
    </div>
  );
};

export default PaymentInput;
